module.exports = __webpack_public_path__ + "static/img/banner1.a337041.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20240913/banner1.jpg
// module id = I45A
// module chunks = 0